<template>
	<el-card class="box-card">
		<el-row>
			<el-col :span="8" :offset="2">
				<el-form label-position="right" label-width="100px">
					<el-form-item label="头像:">
						<el-col :span="24">
							<Img @imgList="imgsImg" :img_num="1" :img_edit="form.head_img"></Img>
						</el-col>
					</el-form-item>
					<el-form-item label="用户名:">
						<el-col :span="16">
							<el-input type="text" v-model="form.user_name" disabled></el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="常用QQ:">
						<el-col :span="16">
							<el-input type="text" v-model="form.qq"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="微信号:">
						<el-col :span="16">
							<el-input type="text" v-model="form.wx"></el-input>
						</el-col>
					</el-form-item>
				</el-form>
				<el-button :loading="this.$store.state.ajaxLoading" @click="set" style="margin-left: 100px;" type="primary">保存信息</el-button>
			</el-col>
		</el-row>
	</el-card>

</template>

<script>
	import {
		userIndex,setUserIndex
	} from '@/api/jd_task'
	import Qs from 'qs'
	import Img from '@/components/Jd/img.vue' // 上传图片组件
	export default {
		components: {
			Img
		},
		data() {
			return {
				form: {
					head_img: [],
					user_name:'',
					qq:'',
					wx:'',
				}
			}
		},
		created(){
			this.getData();
		},
		methods: {
			getData(){
				userIndex(Qs.stringify()).then(response => {
					let r = response.result;
					this.form.head_img = r.head_img;
					this.form.user_name = r.user_name;
					this.form.qq = r.qq;
					this.form.wx = r.wx;
				})
			},
			set(){
				this.$store.commit('setAjaxLoading', true);
				setUserIndex(Qs.stringify(this.form)).then(response => {
					this.$message({
						showClose: true,
						message: '保存成功',
						type: 'success'
					});
				})
			},
			imgsImg(e){
				this.form.head_img = e;
			}
		}
	}
</script>

<style>
</style>
